<div class="w-100 mt-0 tool-container">
  <h4>Download Group Profile</h4>
  <mat-form-field class="me-3">
    <mat-label>Application</mat-label>
    <mat-select [(ngModel)]="groupProfile.app">
      @for (app of applications; track app.value) {
        <mat-option [value]="app.value">
          {{ app.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field class="me-2">
    <mat-label>Profile ID</mat-label>
    <input matInput [(ngModel)]="groupProfile.id" />
  </mat-form-field>
  <mat-form-field class="me-2">
    <mat-label>Group Name</mat-label>
    <input matInput [(ngModel)]="groupProfile.group" />
  </mat-form-field>
  <span class="radio-container ps-2 me-3">
    <mat-label>Save Profile</mat-label>
    <mat-radio-group [(ngModel)]="groupProfile.save">
      <mat-radio-button [value]="true" class="me-3">Yes</mat-radio-button>
      <mat-radio-button [value]="false">No</mat-radio-button>
    </mat-radio-group>
  </span>
  <button
    mat-raised-button
    color="primary"
    class="mx-auto"
    (click)="getGroupProfile()"
    [disabled]="!groupProfile.group || !groupProfile.app"
  >
    Download
  </button>
  @if (groupProfile.status) {
    <h4 class="col-12 {{ groupProfile.statusClass }}">
      {{ groupProfile.status }}
    </h4>
  }
</div>
